import type {CreateServiceFormPayload} from "./create-service.schema";

import {createService} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../service-keys";

export function createServiceMutationOptions() {
  return mutationOptions({
    mutationKey: serviceMutationKeys.createService,
    mutationFn: (payload: CreateServiceFormPayload) => createService(payload),
    onSuccess: async (_id, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: serviceKeys.lists()});
    },
  });
}
